import { useCallback, useMemo } from 'react';

import { useGraphql } from '../graphql';
import { useLoad } from '../load';

// The clinician's people in one request: the patients they care for and the
// invitations they have sent that are open, expired or declined. The
// Dashboard, Patients and Invite patient all read it. data is undefined
// until the answer arrives or when it failed; error, retry and reload are
// useLoad's, reload being what a screen calls after it has sent, resent or
// withdrawn an invitation.
export function usePatients() {
  const graphql = useGraphql();

  const read = useCallback(function() {
    return graphql({
      document: `query Patients {
        patients { id firstName lastName connectedSince openTests toReview }
        sentInvitations { id email name status sentAt respondedAt }
      }`
    });
  }, [ graphql ]);

  const { data, error, retry, reload } = useLoad(read);

  return useMemo(function() {
    return { data, error, retry, reload };
  }, [ data, error, retry, reload ]);
}
